const ENQUIRY = {
  ENQUIRY_NOT_SUBMITTED: 'ENQUIRY_NOT_SUBMITTED',
  ENQUIRY_PUBLIC_CASE_ID_AVAILABLE: 'ENQUIRY_PUBLIC_CASE_ID_AVAILABLE',
  ENQUIRY_PENDING_SUBMISSION: 'ENQUIRY_PENDING_SUBMISSION',
  ENQUIRY_SUBMITTED: 'ENQUIRY_SUBMITTED',
};

export default ENQUIRY;
